import { useAuth } from '../auth/useAuth';
import { hasAnyRole } from '../auth/roleUtils';

/**
 * Hook to check if the current user has moderator or admin privileges.
 * Iteration 5 - Moderation System.
 */
export function useModerator(): boolean {
  const { user } = useAuth();
  return hasAnyRole(user?.roles, 'MODERATOR', 'ADMIN');
}
